import React, { useMemo } from 'react'

import {
  Modal,
} from '@usap/uicomponents'

import Actions from './Actions'
import Items from './Items'
import WarningMedium from '../../../Notification/Types/WarningMedium'
import { StyledContainer } from './OutOfStockItemsWmo.css'

const message = 'One or more items in your cart are currently out of stock. Remove these items to proceed to checkout.'

const OutOfStockItemsWmo = params => {
  const {
    data, showOosProducts, shouldShowOosProducts,
  } = params

  const modalStyle = useMemo(() => ({
    overflow: 'hidden',
  }), [])

  return (
    <Modal
      open={showOosProducts}
      onOpenChange={shouldShowOosProducts}
      header="Out of Stock Items"
      style={modalStyle}
      content={(
        <StyledContainer>
          <WarningMedium message={message} />
          <Items data={data} />
          <Actions data={data} />
        </StyledContainer>
)}
    />

  )
}

export default OutOfStockItemsWmo
